<!-- 百科号、百家号、机构号 -->
<template>
  <div class="box safe-distance-top-header">
    <Header :pageTitle="''" :shareInfo="shareInfo" />
    <div class="detail-box">
      <div class="baseinfo-box">
        <div class="logo-box">
          <img
            class="photo"
            :src="
              detailInfo.coverImg
                ? $global.imgUrl + detailInfo.coverImg
                : require('@/assets/img/mobile-img/jigou-logo.png')
            "
            alt=""
          />
          <div class="name-box">
            <h2>{{ detailInfo.name }}</h2>
          </div>
        </div>
      </div>
      <!-- 资讯/视频/文献 -->
      <div class="tabs-box">
        <van-tabs
          class="tab-box"
          v-model="active"
          color="#4a79f1"
          :ellipsis="false"
          title-active-color="#4a79f1"
          title-inactive-color="#333"
        >
          <van-tab title="简介" name="1">
            <div class="tabs-info">
              <div class="info-lab">名称</div>
              <div class="info-content">{{ detailInfo.name }}</div>
            </div>
            <div class="tabs-info">
              <div class="info-lab">简介</div>
              <div class="info-content" v-html="detailInfo.outline"></div>
            </div>
          </van-tab>
          <van-tab title="资讯" name="2" v-if="userTabs[1]">
            <DetailList
              listType="5"
              :argumentObj="zxObj"
              :listRequest="getZxList"
            />
          </van-tab>
          <van-tab title="论文" name="3" v-if="userTabs[0]">
            <DetailList
              listType="0"
              :argumentObj="lvObj"
              :listRequest="getLvList"
            />
          </van-tab>
          <van-tab title="专著" name="4" v-if="userTabs[2]">
            <DetailList
              listType="2"
              :argumentObj="paramsObj"
              :listRequest="getZzList"
            />
          </van-tab>
          <van-tab title="会议" name="5" v-if="partnerTabs[10]">
            <DetailList
              listType="8"
              :argumentObj="paramsObj"
              :listRequest="getHyList"
            />
          </van-tab>
          <van-tab title="课程" name="6" v-if="partnerTabs[11]">
            <DetailList
              listType="9"
              :argumentObj="paramsObj"
              :listRequest="getKcList"
            />
          </van-tab>
          <van-tab title="商品" name="7" v-if="partnerTabs[9]">
            <DetailList
              listType="11"
              :argumentObj="paramsObj"
              :listRequest="getTsList"
            />
          </van-tab>
          <van-tab title="行业报告" name="8" v-if="partnerTabs[12]">
            <DetailList
              listType="12"
              :argumentObj="paramsObj"
              :listRequest="getBgList"
            />
          </van-tab>
        </van-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "./components/detailHeader.vue";
import DetailList from "./components/detailList.vue";
export default {
  name: "AppusesJiGou",
  //import引入的组件需要注入到对象中才能使用
  components: {
    Header,
    DetailList,
  },
  data() {
    //这里存放数据
    return {
      active: 1,
      detailInfo: {},
      shareInfo: {},
      zxObj: {
        id: this.$route.query.id,
        userType: this.$route.query.item,
      },
      lvObj: {
        id: this.$route.query.id,
        userType: this.$route.query.item,
        articleType: 0,
      },
      paramsObj: {
        companyId: this.$route.query.id,
      },
      userTabs: [false, false, false],
      partnerTabs: {
        9: false,
        10: false,
        11: false,
        12: false,
      },
    };
  },
  created() {
    this.detailList({
      orgId: this.$route.query.id,
    });
    this.getPartnerList();
    this.getUserTabs();
  },
  //方法集合
  methods: {
    async getUserTabs() {
      // userTabs: 0-论文，1-资讯，2-专著
      const { resultCode, data } =
        await this.$apis.hundredServe.getUserDetailTabs({
          userType: 2,
          id: this.$route.query.id,
        });
      if (resultCode === "200") this.userTabs = data;
    },
    async getPartnerList() {
      // content: 9-图书 10-会议 11-课程 12-行业报告 有key就代表tab展示
      const { resultCode, content } =
        await this.$apis.hundredServe.getPartnerDetailTabs({
          userType: "ORGANIZATION",
          companyId: this.$route.query.id,
        });
      if (resultCode === "200") {
        for (const key in this.partnerTabs) {
          this.partnerTabs[key] = Object.keys(content).some(
            (item) => item == key
          );
        }
      }
    },
    // 获取机构详情
    async detailList(data) {
      const resp = await this.$apis.hundredServe.nfdetail(data);
      this.detailInfo = resp.orgInfo;
      this.shareInfo = {
        title: this.detailInfo.name,
        artSummary: this.detailInfo.outline,
        cover: this.detailInfo.coverImg,
        articleId: this.$route.query.id,
        userType: this.$route.query.item,
      };
    },
    // 获取机构资讯
    async getZxList(params) {
      const res = await this.$apis.hundredServe.getBlogList(params);
      if (res.resultCode === "200") {
        return {
          isSuccess: true,
          list: res.data.list,
          total: res.data.total,
        };
      } else {
        return {
          isSuccess: false,
          list: [],
          total: 0,
        };
      }
    },
    // 获取机构论文
    async getLvList(params) {
      const res = await this.$apis.hundredServe.getMobileSyncThesisList(params);
      if (res.resultCode === "200") {
        return {
          isSuccess: true,
          list: res.data.list,
          total: res.data.total,
        };
      } else {
        return {
          isSuccess: false,
          list: [],
          total: 0,
        };
      }
    },
    // 获取机构专著
    async getZzList(params) {
      const res = await this.$apis.hundredServe.getUserDeatilZzList(params);
      if (res.resultCode === "200") {
        return {
          isSuccess: true,
          list: res.data.list.map((item) => ({
            articleType: 2,
            articleId: item.id,
            ...item,
          })),
          total: res.data.total,
        };
      } else {
        return {
          isSuccess: false,
          list: [],
          total: 0,
        };
      }
    },
    // 获取机构会议
    async getHyList(params) {
      const res = await this.$apis.hundredServe.getUserDeatilHyList(params);
      if (res.resultCode === "200") {
        return {
          isSuccess: true,
          list: res.data.list,
          total: res.data.total,
        };
      } else {
        return {
          isSuccess: false,
          list: [],
          total: 0,
        };
      }
    },
    // 获取机构课程
    async getKcList(params) {
      const res = await this.$apis.hundredServe.getUserDeatilKcList(params);
      if (res.resultCode === "200") {
        return {
          isSuccess: true,
          list: res.data.list,
          total: res.data.total,
        };
      } else {
        return {
          isSuccess: false,
          list: [],
          total: 0,
        };
      }
    },
    // 获取机构商品图书
    async getTsList(params) {
      const res = await this.$apis.hundredServe.getUserDeatilTsList(params);
      if (res.resultCode === "200") {
        return {
          isSuccess: true,
          list: res.data.data,
          total: res.data.total,
        };
      } else {
        return {
          isSuccess: false,
          list: [],
          total: 0,
        };
      }
    },
    // 获取行业报告列表
    async getBgList(params) {
      const res = await this.$apis.hundredServe.getUserDeatilBgList({
        ...params,
        type: 4,
      });
      if (res.resultCode === "200") {
        return {
          isSuccess: true,
          list: res.data.data ? res.data.data : [],
          total: res.data.total,
        };
      } else {
        return {
          isSuccess: false,
          list: [],
          total: 0,
        };
      }
    },
  },
};
</script>
<style lang="scss" scoped>
//@import url(); 引入公共css类
.box {
  padding-top: 56px;
  background: #f5f5f5;
  min-height: 100vh;
  overflow: hidden;
  .detail-box {
    padding: 0 12px;
    .baseinfo-box {
      margin-bottom: 12px;
      padding: 16px;
      width: 100%;
      background-color: #ffffff;
      border-radius: 8px;
      .logo-box {
        display: flex;
        align-items: center;
        .photo {
          margin-right: 15px;
          width: 80px;
          height: 80px;
          border-radius: 50%;
        }
        .name-box {
          flex: 1;
          h2 {
            font-size: 16px;
            color: #333333;
            line-height: 24px;
          }
        }
      }
    }
    .tabs-box {
      margin-bottom: 12px;
      width: 100%;
      background-color: #ffffff;
      border-radius: 8px;
      overflow: hidden;
      .tab-box {
        &::v-deep .van-tabs__wrap {
          .van-tabs__nav {
            padding-left: 0;
            padding-right: 0;
            .van-tab__text {
              font-size: 15px;
            }
            .van-tab--active {
              .van-tab__text {
                font-weight: 700;
              }
            }
          }
        }
        &::v-deep .van-tabs__content {
          padding: 16px;
        }
        .tabs-info {
          display: flex;
          margin-bottom: 15px;
          font-size: 14px;
          color: #333333;
          line-height: 24px;
          .info-lab {
            margin-right: 38px;
            width: 60px;
          }
          .info-content {
            flex: 1;
          }
        }
        .science-btn {
          width: 75px;
          height: 29px;
          text-align: center;
          background-color: #4979f1;
          border-radius: 15px;
          font-size: 13px;
          color: #ffffff;
          line-height: 29px;
        }
      }
    }
  }
}
</style>
